module.exports = __webpack_public_path__ + "static/media/sarajevo.46ceb64a.jpg";